// extracted by mini-css-extract-plugin
export var active = "_fk-7";
export var blink = "_fk-8";
export var dropDownSelector = "_fk-4";
export var dropDownWrapper = "_fk-3";
export var fakeCursor = "_fk-6";
export var fontSizeButton = "_fk-9";
export var formQuillEditor = "_fk-0";
export var pressed = "_fk-a";
export var qlBlank = "_fk-1";
export var textFormattingToolbar = "_fk-2";
export var textToolbarOption = "_fk-5";